import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.7);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onClick = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <button
      data-testid="floating-cta"
      onClick={onClick}
      aria-label="Work With Me"
      className={`fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 btn-burgundy transition-all duration-700 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-6 pointer-events-none"
      }`}
      style={{ boxShadow: "0 12px 40px -10px rgba(122, 19, 34, 0.55)" }}
    >
      Work With Me <ArrowRight size={14} strokeWidth={1.5} />
    </button>
  );
}
